// src/components/pointage/apiJustification.js
// Justifier ou corriger une anomalie de pointage du personnel
// (PUT /api/pointages/employes/:id/justifier | /corriger).
//
// Client à part plutôt qu'une entrée dans src/services/api.js, qui porte des
// modifications d'autres chantiers en attente de livraison.

import { getAuthHeaders } from '../../services/api';

async function envoyer(chemin, corps) {
  let reponse;
  try {
    reponse = await fetch(`/api/pointages/employes/${chemin}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(corps)
    });
  } catch {
    throw new Error('Connexion au serveur impossible.');
  }
  let donnees = null;
  try { donnees = await reponse.json(); } catch { donnees = null; }
  if (!reponse.ok || !donnees?.success) {
    throw new Error(donnees?.message || (reponse.status === 403
      ? "Vous n'avez pas la permission de justifier une anomalie de pointage."
      : "L'anomalie n'a pas pu être enregistrée."));
  }
  return donnees.data;
}

export const justifierAnomalie = (pointageId, { motif, commentaire }) =>
  envoyer(`${pointageId}/justifier`, { motif, commentaire });

export const corrigerHeures = (pointageId, { arrivee, depart, motif, commentaire }) =>
  envoyer(`${pointageId}/corriger`, { arrivee, depart, motif, commentaire });

/** La personne connectée peut-elle justifier ou corriger ? { peut_justifier } */
export async function lireDroitsJustification() {
  const reponse = await fetch('/api/pointages/employes/droits-justification', { headers: getAuthHeaders() });
  const donnees = await reponse.json().catch(() => null);
  if (!reponse.ok || !donnees?.success) return { peut_justifier: false };
  return donnees.data;
}

/**
 * « Tout envoyer en compta » : les lignes montrées à l'écran pour une date.
 * Le serveur revérifie chacune et rend celles qu'il a écartées, avec le motif.
 */
export async function envoyerLotEnComptabilite({ ids, datePointage, anneeScolaireId }) {
  let reponse;
  try {
    reponse = await fetch('/api/pointages/employes/envoyer-lot-comptabilite', {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ ids, date_pointage: datePointage, annee_scolaire_id: anneeScolaireId })
    });
  } catch {
    throw new Error('Connexion au serveur impossible.');
  }
  let donnees = null;
  try { donnees = await reponse.json(); } catch { donnees = null; }
  if (!reponse.ok || !donnees?.success) {
    throw new Error(donnees?.message || "L'envoi en comptabilité n'a pas pu être fait.");
  }
  return donnees.data;
}
